import { Link, useNavigate } from '@tanstack/react-router';

import ListBulletsIcon from '@common/assets/icons/list_bullets.svg?react';
import ProfileIcon from '@common/assets/icons/profile.svg?react';
import { IconButton } from '@common/ui/buttons/IconButton';

import { type MatchmakerFriend } from '@entities/matchmaker';

import styles from './FriendLine.module.scss';

export type FriendLineProps = {
  friend: MatchmakerFriend;
};

/** «Для друга: 27, Москва · Изменить» and the way to «Мои рекомендации». */
export const FriendLine = ({ friend }: FriendLineProps) => {
  const navigate = useNavigate();

  return (
    <div className={styles.friendLine} data-test-id="friend-line">
      <Link
        to="/matchmaker/friend"
        className={styles.friend}
        data-test-id="friend-line-edit-link"
      >
        <ProfileIcon className={styles.icon} />
        <span className={styles.text}>
          Для друга:{' '}
          <span className={styles.value} data-test-id="friend-line-value">
            {friend.age}, {friend.city}
          </span>
        </span>
        <span className={styles.edit}>Изменить</span>
      </Link>
      <IconButton
        testId="friend-line-recommendations-button"
        aria-label="Мои рекомендации"
        size={500}
        variant="actionSecondary"
        className={styles.recommendations}
        onClick={() => navigate({ to: '/matchmaker/recommendations' })}
      >
        <ListBulletsIcon />
      </IconButton>
    </div>
  );
};
